<template>
  <div>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="绑定设备" name="0"></el-tab-pane>
      <el-tab-pane label="区域设备" name="1" v-if="level === 'AREA'"></el-tab-pane>
    </el-tabs> -->
    <com-equ-search typeOfView="partner" @search="handleSearch"></com-equ-search>
    <com-equ-list :default-params="defaultParams" type-of-view="partner" ref="table"></com-equ-list>
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.defaultParams.partnerCode = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      defaultParams: {},
      activeName: '0'
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleClick() {
      if (this.activeName === '1') {
        this.defaultParams.areaPartnerCode = this.code
        delete this.defaultParams.partnerCode
        this.$refs.table.init()
        return
      }

      this.defaultParams.partnerCode = this.code
      delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    }
  }
}
</script>

<style lang="scss" scoped></style>
